import { AxiosInstance, AxiosResponse } from "axios";

import {
  TransactionResponseDTO,
  TransactionItemModel,
  CancelTransactionsInputDTO,
  CancelTransactionsOutputDTO,
  ProofOfTransaction
} from "../entities/Transactions";

const resourcePrefix = "/Terminal";

export class TransactionsResource {
  apiProvider: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.apiProvider = instance;
  }

  async transactionsResume(): Promise<AxiosResponse<TransactionResponseDTO>> {
    return this.apiProvider.get(
      `${resourcePrefix}/ConsultarResumoDeTransacoes`
    );
  }

  async findTransactions(): Promise<AxiosResponse<TransactionItemModel[]>> {
    return this.apiProvider.get(`${resourcePrefix}/ConsultarTransacoes`);
  }

  async dailyClosing(): Promise<AxiosResponse<string>> {
    return this.apiProvider.get(`${resourcePrefix}/ConsultarFechamentoDiario`, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }

  async getProofOfTransaction(
    lngAutorizacao: number
  ): Promise<AxiosResponse<ProofOfTransaction>> {
    return this.apiProvider.get(
      `Autorizador/EmitirComprovanteTransacaoApp?lngAutorizacao=${lngAutorizacao}`
    );
  }

  async cancelTransaction(
    data: CancelTransactionsInputDTO
  ): Promise<AxiosResponse<CancelTransactionsOutputDTO>> {
    return this.apiProvider.post(`${resourcePrefix}/CancelarTransacao`, data, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
}
